import { useState, useMemo } from 'react';
import { UserWithMembership } from '@/hooks/useUsers';
import { useFuzzyUserSearch } from './useFuzzyUserSearch';

export const useUserFilters = (users: UserWithMembership[]) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedRole, setSelectedRole] = useState('all');
  const [showActiveOnly, setShowActiveOnly] = useState(false);
  const [showInactiveOnly, setShowInactiveOnly] = useState(false);

  // Apply fuzzy search first
  const searchFilteredUsers = useFuzzyUserSearch(users, searchTerm);

  // Apply additional filters
  const filteredUsers = useMemo(() => {
    let filtered = searchFilteredUsers;

    // Role filter
    if (selectedRole !== 'all') {
      filtered = filtered.filter(user => user.role === selectedRole);
    }

    // Active/Inactive filters
    if (showActiveOnly && !showInactiveOnly) {
      filtered = filtered.filter(user => user.membership_is_active);
    } else if (showInactiveOnly && !showActiveOnly) {
      filtered = filtered.filter(user => !user.membership_is_active);
    }
    // If both are true or both are false, show all users

    return filtered;
  }, [searchFilteredUsers, selectedRole, showActiveOnly, showInactiveOnly]);

  const handleActiveOnlyChange = (value: boolean) => {
    setShowActiveOnly(value);
    if (value) {
      setShowInactiveOnly(false);
    }
  };

  const handleInactiveOnlyChange = (value: boolean) => {
    setShowInactiveOnly(value);
    if (value) {
      setShowActiveOnly(false);
    }
  };

  return {
    searchTerm,
    setSearchTerm,
    selectedRole,
    setSelectedRole,
    showActiveOnly,
    setShowActiveOnly: handleActiveOnlyChange,
    showInactiveOnly,
    setShowInactiveOnly: handleInactiveOnlyChange,
    filteredUsers,
  };
};